<script lang="ts" setup>
const t2 = useT2Base({
  Loading: 'Kraunama',
})

const props = defineProps<{ notify: ReturnType<typeof useNotify> }>()
const init3 = useInited('init3')
const timer = useTimeout()

const ui = computed(() => {
  const res = props.notify.notify.value
  const msg = res.success || res.error || (res.isLoading ? t2('Loading') + '...' : undefined)
  return { data: res, msg }
})

const data = shallowReactive({
  delayedMsg: ui.value.msg,
})

const show = computed(() => {
  const slow = data.delayedMsg
  const fast = ui.value.msg
  return { msg: fast || slow, outer: !!fast || !!slow, innter: !!fast && !!slow }
})

watch(
  () => ui.value.msg,
  (val) => timer.set(() => (data.delayedMsg = val), 100)
)

const render = useIsRender(() => show.value.outer)
</script>

<template>
  <LazyUiNotifyLazy v-if="render || init3" :innter="show.innter" :outer="show.outer" :loading="ui.data.isLoading" :error="ui.data.error" :notify :success="ui.data.success" :msg="show.msg" />
</template>
